export default {

  computed: {
    hoverId: {
      get() {
        return this.$root.hoverId
      },

      set(hoverId) {
        this.$root.hoverId = hoverId
      }
    }
  },

  methods: {
    isHovered(key){
      return this.hoverId && this.hoverId == key
    }
  }

}